import Box, { Flex } from '@spotnana/pixel-react/dist/Box';
import Grid from '@spotnana/pixel-react/dist/Grid';
import Image from '@spotnana/pixel-react/dist/Image';
import Typography from '@spotnana/pixel-react/dist/Typography';
import Info from '@spotnana/pixel-react/dist/Icons/Info';
import Tooltip from '@spotnana/pixel-react/dist/Tooltip';
import { getPaymentCardLogo, ICardCompanyEnum, airTranslationKeys } from 'obt-common';
import { useTranslation } from 'react-i18next';

const UatpPassPlus = (): JSX.Element => {
  const uatpCardCode = ICardCompanyEnum[ICardCompanyEnum.AIR_TRAVEL_UATP];
  const { t } = useTranslation('FLIGHTS');
  const { t: tt } = useTranslation('WEB');
  const { UNITED_PASSPLUS_RATE, FLIGHT_LEVEL_UATP_INFO } = airTranslationKeys;

  return (
    <Grid.Row start="xs">
      <Grid.Col>
        <Box>
          <Image
            fallback={<Typography variation="label">{uatpCardCode}</Typography>}
            src={getPaymentCardLogo(uatpCardCode)}
            alt={uatpCardCode}
            loaderType="rectangle"
          />
        </Box>
      </Grid.Col>
      <Grid.Col>
        <Flex alignItems="center" height="100%">
          <Typography variation="small" color="text.label" aria-label={tt('United PassPlus Rate')} mr={2}>
            {t(UNITED_PASSPLUS_RATE)}
          </Typography>
          <Tooltip placement="bottom-start" title={t(FLIGHT_LEVEL_UATP_INFO)} variation="light">
            <Box cursor="pointer" pt="2px">
              <Info primaryColor="#838999" height={12} width={12} />
            </Box>
          </Tooltip>
        </Flex>
      </Grid.Col>
    </Grid.Row>
  );
};

export default UatpPassPlus;
